goog.provide("shadow.js.shim.module$$mui$material$CardHeader$default");
shadow.js.shim.module$$mui$material$CardHeader$default = shadow.js.shim.module$$mui$material$CardHeader.default;
